import React from "react";
import {
  BarChart,
  Bar,
  /*Cell,*/
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const BarChartComponent = (props) => {
  return (
    <div style={{ height: "400px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={props.data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />

          {props.columns ? (
            props.columns.map((column) => {
              var randomColor = Math.floor(Math.random() * 16777215).toString(
                16
              );
              const color = "#" + randomColor;

              return <Bar dataKey={column} fill={color} />;
            })
          ) : (
            <Bar dataKey="Quantidade" fill="#8884d8" />
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartComponent;
